import './search-input.scss';

import { type FC } from 'react';

import usePaginationParams from '@/hooks/usePaginationParams';
import SearchIcon from '@/media/icons/search.svg?react';

import Input, { type IInputProps } from '../ui/input';

type TSearchInputProps = IInputProps & {
  searchTermFormatter?: (value: string) => string;
  searchTermParamName?: string;
};

const SearchInput: FC<TSearchInputProps> = ({
  searchTermFormatter,
  searchTermParamName = 'searchTerm',
  ...rest
}) => {
  const { searchValue, handleSearch } = usePaginationParams({
    searchTermFormatter,
    searchTermParamName
  });

  return (
    <Input
      {...rest}
      placeholder={rest.placeholder || 'Поиск'}
      // Приоритет внешнего value над внутренним searchValue
      value={rest.value ?? searchValue}
      onChange={
        rest.onChange
          ? rest.onChange
          : (e) => {
              handleSearch(e.target.value);
            }
      }
      onKeyDown={(e) => {
        if (e.key === 'Enter') e.preventDefault();
      }}
      endContent={
        <span className="search-input__icon-container">
          <SearchIcon className="search-input__icon" />
        </span>
      }
    />
  );
};

export default SearchInput;
